import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  abilities: service(),
  coachingService: service(),

  beforeModel(transition) {
    if (this.abilities.noCoachingAbility('edit_report')) {
      transition.abort();
    }
  },

  model() {
    let parentModel = this.modelFor('coaching.individuals.individual.report');
    let changeset = this.coachingService.createChangesetForReport(
      parentModel.individualRecord,
      parentModel.record,
    );
    let prevReport = parentModel.individualRecord.previousReport(
      parentModel.record,
    );
    let prevChangeset = null;
    if (prevReport != null) {
      prevChangeset = this.coachingService.createChangesetForReport(
        parentModel.individualRecord,
        prevReport,
      );
    }

    return Object.assign({}, parentModel, { changeset, prevChangeset });
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
